import React from "react";
import { withRouter } from "react-router-dom";
import LoadSpinner from "../../../common/spinner/loadSpinner";
import Menucustom from "../../../common/menu/menucustom";
import DashboardRecuperoCrediti from "./dashboardRecuperoCreditiService";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import {
  calculateTimeDifferenceTwoDates,
  geDataFormat,
  getColorState,
} from "../../../common/utils";
import { CDBCard, CDBCardBody, CDBDataTable, CDBContainer } from "cdbreact";
import { CSVLink, CSVDownload } from "react-csv";
// import ingiunzioniList from "../../../common/mookup/MookUpIngunzioni";
toast.configure();

class RecuperoCrediti extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dataTableIngunzioni: [],
      dataTableIngunzionimodificate: [],
      dataTableIngunzioniCSVDownload: [],
      headerDataTableIngunzioni: [],
      searchNumIngunzioni: "",
      searchDataEmissione: "",
      searchNome: "",
      searchCognome: "",
      export:[],
      searchCF: "",
      loading: true,
      filtro: {
        dataInizio: "",
        dataFine: "",
      },
    };
    this.geDataFormat = geDataFormat.bind(this);
    this.getColorState = getColorState.bind(this);
    this.onRowClick = this.onRowClick.bind(this);
    this.csvLinkEl = React.createRef();
  }

  componentDidMount() {
    this.dashboardRecuperoCrediti = new DashboardRecuperoCrediti();
    var search = this.props.location.search;
    // var stato = "aperte";
    // if (search != null && search.includes("?")) {
    //   stato = search.substring(1, search.lenght);
    // }
    this.state.filtro.dataFine = moment(new Date()).format("YYYY-MM-DD")
    this.state.filtro.dataInizio = moment(this.state.filtro.dataFine, "YYYY-MM-DD").subtract(29, "d").format("YYYY-MM-DD")
    this.getDataTable();
  }


  getExportCSV() {
    this.dashboardRecuperoCrediti.getDataTableSanzioni(
      this.state.filtro.dataInizio,
      this.state.filtro.dataFine,
      this.onSuccesExportCSV.bind(this)
    );
  }
  // (dati.importo / 100).toFixed(2),
  onSuccesExportCSV(resultHeader, resultBody) {
    //primi campi del CSV
    if(resultBody.length <= 0){
      toast.error("Non ci sono record da esportare")
    }else{
    this.setState({export:[]});
    resultBody.map((val) => {
      this.state.export = [
        ...this.state.export,
        {
          idRecuperoCerditi:val.id,
          ImportoDaRecuperare:parseFloat(val.importo / 100),
          dataCreazioneRecuperoCrediti:geDataFormat(val.dataCreazione),
          numRecuperoCredito:val.numRecuperoCredito,
          idSanzione:val.sanzioni.idSanzione,
          idAnagraficaTrasgressore:val.sanzioni.anagraficaTrasgressore.idAnagraficaTrasgressore,
          nome:val.sanzioni.anagraficaTrasgressore.nome,
          cognome:val.sanzioni.anagraficaTrasgressore.cognome,
          codiceFiscale:val.sanzioni.anagraficaTrasgressore.codiceFiscale,
          dataDiNascita:geDataFormat(val.sanzioni.anagraficaTrasgressore.dataDiNascita),
          luogoDiNascita:val.sanzioni.anagraficaTrasgressore.luogoDiNascita,
          isMinorenne:val.sanzioni.anagraficaTrasgressore.isMinorenne,
          numeroDocumento:val.sanzioni.anagraficaTrasgressore.numeroDocumento,
          dataRilascioDocumento:geDataFormat(val.sanzioni.anagraficaTrasgressore.dataRilascioDocumento),
          enteRilascioDocumento:val.sanzioni.anagraficaTrasgressore.enteRilascioDocumento,
          comuneDiResidenza:val.sanzioni.anagraficaTrasgressore.comuneDiResidenza,
          inidirizzoDiResidenza:val.sanzioni.anagraficaTrasgressore.inidirizzoDiResidenza,
          inidirizzoNumeroDiResidenza:val.sanzioni.anagraficaTrasgressore.inidirizzoNumeroDiResidenza,
          capDiResidenza:val.sanzioni.anagraficaTrasgressore.capDiResidenza,
          provinciaDiResidenza:val.sanzioni.anagraficaTrasgressore.provinciaDiResidenza,

          idAnagraficaTrasgressorePotesta:val.sanzioni.anagraficaPotestaTrasgressore.idanagraficaPotestaTrasgressore,
          nomePotesta:val.sanzioni.anagraficaPotestaTrasgressore.nome,
          cognomePotesta:val.sanzioni.anagraficaPotestaTrasgressore.cognome,
          codiceFiscalePotesta:val.sanzioni.anagraficaPotestaTrasgressore.codiceFiscale,
          dataDiNascitaPotesta:geDataFormat(val.sanzioni.anagraficaPotestaTrasgressore.dataDiNascita),
          luogoDiNascitaPotesta:val.sanzioni.anagraficaPotestaTrasgressore.luogoDiNascita,
          isMinorennePotesta:val.sanzioni.anagraficaPotestaTrasgressore.isMinorenne,
          numeroDocumentoPotesta:val.sanzioni.anagraficaPotestaTrasgressore.numeroDocumento,
          dataRilascioDocumentoPotesta:geDataFormat(val.sanzioni.anagraficaPotestaTrasgressore.dataRilascioDocumento),
          enteRilascioDocumentoPotesta:val.sanzioni.anagraficaPotestaTrasgressore.enteRilascioDocumento,
          comuneDiResidenzaPotesta:val.sanzioni.anagraficaPotestaTrasgressore.comuneDiResidenza,
          inidirizzoDiResidenzaPotesta:val.sanzioni.anagraficaPotestaTrasgressore.inidirizzoDiResidenza,
          inidirizzoNumeroDiResidenzaPotesta:val.sanzioni.anagraficaPotestaTrasgressore.inidirizzoNumeroDiResidenza,
          capDiResidenzaPotesta:val.sanzioni.anagraficaPotestaTrasgressore.capDiResidenza,
          provinciaDiResidenzaPotesta:val.sanzioni.anagraficaPotestaTrasgressore.provinciaDiResidenza,

          idAnagrafiaTipolagiaSanzione:val.sanzioni.anagraficaTipologiaSanzione.provinciaDiResidenza,
          nomeViolazione:val.sanzioni.anagraficaTipologiaSanzione.nomeViolazione,
          importo:parseFloat(val.sanzioni.anagraficaTipologiaSanzione.importo / 100),
          importoRidotto:parseFloat(val.sanzioni.anagraficaTipologiaSanzione.importoRidotto / 100),
          aggiungiPrezzoTratta:val.sanzioni.anagraficaTipologiaSanzione.aggiungiPrezzoTratta,
          speseProcedura:val.sanzioni.anagraficaTipologiaSanzione.speseProcedura,

          nomeStato:val.sanzioni.anagraficaStati.nomeStato,

          numeroSanzione:val.sanzioni.numeroSanzione,
          protocolloSanzione:val.sanzioni.protocolloSanzione,
          matricolaControllore:val.sanzioni.matricolaControllore,       
          importoSanzione:val.sanzioni.importo,       
          dataDiEmissione:geDataFormat(val.sanzioni.dataDiEmissione),       
          annotazioneControllore:val.sanzioni.annotazioneControllore,       
          isverbaleFattoABordo:val.sanzioni.isverbaleFattoABordo,       
          importoRidottoSanzione:val.sanzioni.importoRidotto,       
          matricolaMezzo:val.sanzioni.matricolaMezzo, 

          idIngiunzione:val.ingiunzioni.id,       
          numIngiunzione:val.ingiunzioni.numIngiunzione,        
          importoIngiunzione:parseFloat(val.ingiunzioni.importo / 100),        
          dataCreazioneIngiunzione:geDataFormat(val.ingiunzioni.dataCreazione),            
          
          
        }
      ];
      
      
    })


    this.setState(
      {
        dataTableIngunzioniCSVDownload: this.state.export,
      },
      () => {
        setTimeout(() => {
          this.csvLinkEl.current.link.click();
        });
      }
    );
    }
  }


  onClickCSVDownLoad() {
  this.getExportCSV();
    this.csvLink.current.link.click();
    // console.log(this.csvLink.current.link)
  }

  

  getDataTable() {
    this.dashboardRecuperoCrediti.getDataTableSanzioni(
      this.state.filtro.dataInizio,
      this.state.filtro.dataFine,
      this.onSuccessLoadDataTableSanzione.bind(this)
    );
  }

  onSuccessLoadDataCharter(result) {
    this.setState((this.data = result));
  }
  onSuccessLoadDataTableSanzione(resultHeader, resultBody) {
    var sanzioni = resultBody;
    var numSanzioniInscadenza = 0;
    for (let i = 0; i < sanzioni.length; i++) {
      var sanzione = sanzioni[i];
      var allaScadenza = "-";
      if ("Caricato" === sanzioni[i].statoSanzione) {
        var diff = calculateTimeDifferenceTwoDates(
          new Date(),
          moment(sanzione.dataEmissione, "DD/MM/YYYY").toDate()
        );
        allaScadenza = 60 - parseInt(diff, 10);
        var val = "-";
        if (allaScadenza < 0) {
          val = "Scaduto";
          numSanzioniInscadenza += 1;
        } else {
          val = "Scade tra " + allaScadenza + " giorni";
          if (allaScadenza < 5) numSanzioniInscadenza += 1;
        }
        sanzione.giorniAllaScadenza = val;
      } else {
        sanzione.giorniAllaScadenza = " - ";
      }
    }
    // var mexError =
    //   "Attenzione " + numSanzioniInscadenza + " sanzioni in scadenza!";
    // if (numSanzioniInscadenza > 5)
    //   toast.warn(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else if (numSanzioniInscadenza > 10)
    //   toast.error(mexError, { position: toast.POSITION.TOP_RIGHT });
    // else toast.info(numSanzioniInscadenza + " sanzioni in scadenza ");
    this.setState((this.headerDataTableIngunzioni = resultHeader));
    this.setState({ dataTableIngunzioniCSV: resultBody });
    //qui si riempe con il BE
    // this.setState({ dataTableIngunzioni: resultBody });
    //qui con il mookUp
    this.setState({ dataTableIngunzioni: this.state.dataTableIngunzioniCSV });
    this.setState({ loading: false });
  }

  onRowClick(row) {
    row.statoSanzione = "";

    var search = this.props.location.search;
    var stato = "aperte";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    this.id = {};
    if (stato === "aperte") {
      row.statoSanzione = "IngiunzioneAperta";
    }
    if (stato === "pagate") {
      row.statoSanzione = "IngiunzionePagata";
    }
    if (stato === "chiuse") {
      row.statoSanzione = "IngiunzioneChiusa";
    }

    sessionStorage.removeItem("rowSanzione");
    sessionStorage.setItem("rowSanzione", JSON.stringify(row));
    this.props.history.push("/detailSanzione");
  }

  // onIngiunzioneClick() {
  //   // sessionStorage.removeItem("rowSanzioneIngiunzione");
  //   // sessionStorage.setItem("rowSanzioneIngiunzione", JSON.stringify(row));

  //   console.log(this.props.history);

  //   if (this.props.history.location.pathname === "/ingiunzioni") {
  //     // sessionStorage.removeItem("rowIngiunzione");
  //     // sessionStorage.setItem("rowIngiunzione", JSON.stringify(row))
  //     this.props.history.push("/Ingiunzione");
  //   } else {
  //     this.props.history.push("/detailSanzione");
  //   }
  // }

  onRowClickPush(idIngiunzione) {
    // sessionStorage.removeItem("rowIngiunzione");
    // window.sessionStorage.setItem("rowIngiunzione", JSON.stringify(row));

    var search = this.props.location.search;
    var stato = "aperte";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }
    this.statoIngiunzione = {};
    if (stato === "aperte") {
      this.statoIngiunzione = "IngiunzioneAperta";
    }
    if (stato === "pagate") {
      this.statoIngiunzione = "IngiunzionePagata";
    }
    if (stato === "chiuse") {
      this.statoIngiunzione = "IngiunzioneChiusa";
    }

    if (this.props.history.location.pathname === "/ingiunzioni") {
      sessionStorage.removeItem("rowIngiunzione");
      sessionStorage.setItem(
        "rowIngiunzione",
        JSON.stringify({ id: idIngiunzione , statoSanzione:this.statoIngiunzione})
      );
      this.props.history.push("/Ingiunzione");
    } else {
      this.props.history.push("/detailSanzione");
    }
  }

  dataObj() {
    this.state.dataTableIngunzionimodificate = [];
    this.state.dataTableIngunzioni.map((dati) => {
      this.state.dataTableIngunzionimodificate = [
        ...this.state.dataTableIngunzionimodificate,
        {
          numRecuperoCredito: dati.numRecuperoCredito,
          numInginzione: (
          <>
            <button
              className="btn btn-link"
              onClick={() => {
                this.id = {};
               
                  this.id = {
                    id: dati.ingiunzioni.numIngiunzione,
                    statoSanzione: dati.ingiunzioni.anagraficaStati.nomeStato,
                  };
                                  
                sessionStorage.removeItem("rowIngiunzione");
                sessionStorage.setItem(
                  "rowIngiunzione",
                  JSON.stringify(this.id)
                );
                this.props.history.push("/Ingiunzione");
              }}
            >
              {dati.ingiunzioni.numIngiunzione}
            </button>
          </>
          ),
          numSanzione: (
            <>
              <button
                className="btn btn-link"
                onClick={() => {
                  this.id = {};
                 
                    this.id = {
                      id: dati.sanzioni.idSanzione,
                      statoSanzione: "RecuperoCrediti",
                    };
                                    
                  sessionStorage.removeItem("rowSanzione");
                  sessionStorage.setItem(
                    "rowSanzione",
                    JSON.stringify(this.id)
                  );
                  this.props.history.push("/detailSanzione");
                }}
              >
                {dati.sanzioni.numeroSanzione}
              </button>
            </>
          ),
          dataCreazione: geDataFormat(dati.dataCreazione),
          importo:
            parseFloat(dati.importo / 100)
              .toString()
              .replace(".", ",") + "€",
        },
      ];
    });
    var data = {
      columns: this.headerDataTableIngunzioni,
      rows: this.state.dataTableIngunzionimodificate,
    };

    // for (const item of this.state.dataTableIngunzionimodificate) {
    //   item.clickEvent = () => this.onRowClickPush(item.id);
    // }

    // this.state.dataTableIngunzionimodificate.map((item) => {
    //   item.clickEvent = () => this.onRowClickPush(item.numIngiunzione);
    // });
    return data;
  }

  onChangeDataInizio(event) {
    this.state.filtro.dataInizio = event.target.value;
    this.setState({ filtro: this.state.filtro });
  }

  onChangeDataFine(event) {
    this.state.filtro.dataFine = event.target.value;
    this.setState({ filtro: this.state.filtro });

    // var search = this.props.location.search;
    // var stato = "aperte";
    // if (search != null && search.includes("?")) {
    //   stato = search.substring(1, search.lenght);
    // }
    // this.getDataTable(
    //   stato,
    //   this.state.filtro.dataInizio,
    //   this.state.filtro.dataFine
    // );
  }

  renderTableData() {
    if (
      this.state.dataTableIngunzioni &&
      this.state.dataTableIngunzioni.length > 0
    ) {
      return (
        <CDBContainer>
          <CDBCard border>
            <div className="container">
              <div className="row">
                <div className="col">
                  <div className="col">Data Inizio: </div>
                  <div className="col">
                    <input
                      value={this.state.filtro.dataInizio}
                      type="date"
                      className="form-control"
                      onChange={this.onChangeDataInizio.bind(this)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="col">Data Fine: </div>
                  <div className="col">
                    <input
                      value={this.state.filtro.dataFine}
                      type="date"
                      className="form-control"
                      onChange={this.onChangeDataFine.bind(this)}
                    />
                  </div>
                </div>
                <div className="col">
                  {/* <div className="col">Filtri: </div> */}
                  <br></br>
                  <div className="col">
                    <button
                      className="btn btn-warning"
                      style={{ width: "100%" }}
                      onClick={() => {
                        var search = this.props.location.search;
                        var stato = "aperte";
                        if (search != null && search.includes("?")) {
                          stato = search.substring(1, search.lenght);
                        }
                        this.getDataTable(stato);
                      }}
                    >
                      Applica Filtri
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <CDBCardBody>
              <CDBDataTable
                sortable={false}
                responsiveSm={true}
                responsiveMd={true}
                responsiveLg={true}
                pagesAmount={3}
                entriesLabel={""}
                infoLabel={["Mostra da", "a", "di", "Recupero Crediti totali"]}
                paginationLabel={["<-", "->"]}
                striped
                bordered
                hover
                checkbox
                data={this.dataObj()}
                materialSearch
              />
            </CDBCardBody>
          </CDBCard>
        </CDBContainer>
      );
    } else {
      return (
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="col">Data Inizio: </div>
              <div className="col">
                <input
                  value={this.state.filtro.dataInizio}
                  type="date"
                  className="form-control"
                  onChange={this.onChangeDataInizio.bind(this)}
                />
              </div>
            </div>
            <div className="col">
              <div className="col">Data Fine: </div>
              <div className="col">
                <input
                  value={this.state.filtro.dataFine}
                  type="date"
                  className="form-control"
                  onChange={this.onChangeDataFine.bind(this)}
                />
              </div>
            </div>
            <div className="col">
              {/* <div className="col">Filtri: </div> */}
              <br></br>
              <div className="col">
                <button
                  className="btn btn-warning"
                  style={{ width: "100%" }}
                  onClick={() => {
                    var search = this.props.location.search;
                    var stato = "aperte";
                    if (search != null && search.includes("?")) {
                      stato = search.substring(1, search.lenght);
                    }
                    this.getDataTable(stato);
                  }}
                >
                  Applica Filtri
                </button>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }

  render() {

    var search = this.props.location.search;
    var stato = "aperte";
    if (search != null && search.includes("?")) {
      stato = search.substring(1, search.lenght);
    }


    let content = this.state.loading ? (
      <LoadSpinner />
    ) : (
      <div id="wrapper">
        <Menucustom />
        <div className="container-fluid">
          <br />
          <br />
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h1 mb-2 text-gray-800">
              Recupero Crediti<br></br>
              <small
                style={{ fontSize: "14px" }}
                className="mb-2 text-gray-800"
              >
                Recupero Crediti &#8594; In Lavorazione
              </small>
            </h1>
            <button
              type="button"
              class="btn btn-warning"
              onClick={this.onClickCSVDownLoad.bind(this)}
            >
              {" "}
              <i className="fas fa-download fa-sm text-white"></i> &nbsp;Esporta
              Recupero Crediti
            </button>
            {/* <CSVLink data={this.state.dataTableIngunzioniCSV} separator={";"} filename="Ingiunzioni.csv"> */}
              {/* <button type="button" class="btn btn-warning">
                {" "}
                <i className="fas fa-mail-bulk fa-sm text-white"></i>{" "}
                &nbsp;Esporta Ingunzioni
              </button> */}
            {/* </CSVLink> */}
            <CSVLink
              data={this.state.dataTableIngunzioniCSVDownload} separator={";"} ref={this.csvLinkEl} filename={"RecuperoCrediti.csv"}
            />
          </div>
          <br />
          <br />
          <div className="col">{this.renderTableData()}</div>
        </div>
      </div>
    );
    return <div>{content}</div>;
  }
}
export default withRouter(RecuperoCrediti);
